module.exports = __webpack_public_path__ + "img/support_d7.d915d6dc.png";